import { render, staticRenderFns } from "./IssueConversion.vue?vue&type=template&id=b368a28c&"
import script from "./IssueConversion.vue?vue&type=script&lang=ts&"
export * from "./IssueConversion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports